export class SelectorProvince {
  constructor(public code: string,
              public name: string,
              public disabled?: boolean,
              public authDisabled?: boolean) {}
}